// Function to dismiss notification and set a cookie
function dismissNotification(this: HTMLElement) {
	const notification = this.closest(".notification");
	if (!notification) {
		return;
	}

	const id = notification.getAttribute("data-notification-id");
	if (!id && id !== "0") {
		return;
	}

	const notificationInterval = notification.getAttribute('data-notification-interval');
	const hours = notificationInterval ? parseFloat(notificationInterval) : -1;

	// hours > 0:  number of hours to wait before showing again
	// hours = 0:  show again on next page load
	// hours = -1: never show again
	// Record that the notification was dismissed and when it should reappear if applicable
	if (hours !== 0) {
		const storage = window.localStorage.getItem("plaudit-dismissed-notifications");
		const expiration = hours > -1 ? Date.now() + hours * 60 * 60 * 1000 : 0;
		window.localStorage.setItem("plaudit-dismissed-notifications", storage ? `${storage};${id}:${expiration}` : `${id}:${expiration}`);
	}

    // Hide the specific notification on the frontend
	notification.classList.remove("displayed");
}

function getDismissedNotifications() {
	const dismissedNotifications: [number, number][] = window.localStorage.getItem("plaudit-dismissed-notifications")?.split(';')
			.map(t => t.split(':').map(v => parseInt(v)) as [number, number])
			// This filters out dismissal records that either no longer correspond to an active notification or that have expired
			.filter(([id, expiration]) => document.getElementById(`notification-${id}`) && (expiration === 0 || expiration > Date.now()))
		?? [];

	// We write the filtered list back into local storage in order to trim unused notifications from the list
	window.localStorage.setItem("plaudit-dismissed-notifications", dismissedNotifications.map(v => v.join(':')).join(';'));
	return dismissedNotifications.map(([id]) => id);
}

// Run the code only if there are notifications on the page
document.addEventListener('DOMContentLoaded', () => {
	const wireUpNotification = (notification: Element) => {
		notification.classList.toggle("notification--js-ready", true);

		const id = notification.getAttribute('data-notification-id');
		if (id && !getDismissedNotifications().includes(parseInt(id))) {
			notification.classList.toggle("displayed", true);

			if (notification instanceof HTMLDialogElement) {
				notification.showModal();
			}

			for (const button of notification.querySelectorAll('.dismiss,a')) {
				button.addEventListener('click', dismissNotification);
			}
		}
	}

	for (const notification of document.querySelectorAll('[data-notification-id]:not(.notification--js-ready)')) {
		wireUpNotification(notification);
	}

	new MutationObserver(mutations => {
		for (const mutation of mutations) {
			for (const mutationRootNode of mutation.addedNodes) {
				if (mutationRootNode instanceof Element) {
					if (mutationRootNode.classList.contains("notification") && !mutationRootNode.classList.contains("notification--js-ready")
						&& mutationRootNode.hasAttribute("data-notification-id")
					) {
						wireUpNotification(mutationRootNode);
					} else {
						for (const notification of mutationRootNode.querySelectorAll('[data-notification-id]:not(.notification--js-ready)')) {
							wireUpNotification(notification);
						}
					}
				}
			}
		}
	}).observe(document.body, {subtree: true, childList: true});
});
